import { Box, Grid, Stack } from "@mui/joy"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import { triggerSair } from "../auth/AuthenticationSlice";



function NavBar() {

    var dispatch = useDispatch();

    return <Grid container>
        <Grid xs={12}>
            <Box sx={{padding: "5px 10px"}}>
                <Stack direction={"row"} spacing={1}>
                <Link to="/"> Home </Link>
                <Link to="/medias"> Medias </Link>
                <Link to="/contents"> Contents </Link>
                <Link to="/trilha-builder"> Trilhas </Link>
                <Link to="/tracker"> Tracker </Link>
                <Link to="/badges"> Badges </Link>
                <Link onClick={() => {
                    dispatch(triggerSair())
                }}> Sair </Link>
            </Stack>
            </Box>
        </Grid>
    </Grid>
}

export default NavBar